<ui-label [config]="platformGroup ? labelConfig[platformGroup] : defaultLabelConfig">{{
  title | translate
}}</ui-label>
